/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { namespace } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ResultPageStatusEnum } from '@/components/result-page';
import { PreApplyItem } from '@/po/PreApplyItem';
import { OrdersV2 } from '@/api/ordersV2/types';
import { HaiXiaoQueryStatusType } from '@/api/homeV2Status/types';
import ProductCommodity, { MASHANG_COMMODITY, isNewYhChannel } from '@/shared/commodity';
import { CardBindTypeEnum } from '@/api/apply-product/types';
import { alipayOrBank } from '@/api/apply-product';
import ChangeChannelList from '@/components/change-channel';
import { OrderResultEnum } from '@/enums/orderV2';

import NewResultPage from '../new-result-page';
import { handleChannelClick } from '../../utils';

const style = require('./index.module.scss');

const ApplyResultStore = namespace('applyResult');
const HomeStore = namespace('home');

@Component
export default class ApplySuccess extends Vue {
  @Prop(String) readonly commodityId!: string;

  @ApplyResultStore.State orderDetail!: OrdersV2.OrderDetail | null;

  @HomeStore.State haiXiaoQueryData!: HaiXiaoQueryStatusType | null;

  @ApplyResultStore.State commodityDetail!: OrdersV2.CommodityDetail | null;

  /** 是否显示老客升级入口 */
  @Prop(Boolean) readonly showUpgrade?: boolean;

  /** 是否显示领取额度入口，锁客逻辑 */
  @Prop(Boolean) readonly showPreApply?: boolean;

  /** 去授信获取新额度 */
  private goPreApply() {
    this.$emit('goPreApply');
  }

  private cardBindType = CardBindTypeEnum.BANK;

  private async mounted() {
    // 银河渠道 通过接口获取支付类型
    if (isNewYhChannel(this.commodityId) && this.orderDetail) {
      const { payType } = await alipayOrBank({
        loanOrderId: this.orderDetail.loanOrderId,
      });
      this.cardBindType = payType;
    } else {
      this.cardBindType = CardBindTypeEnum.BANK;
    }

    if (this.showUpgrade) {
      this.$ubtModuleExposeNew('finance_withdrawResult_upgradeApply', {
        commodityId: this.commodityId,
        applyStatus: OrderResultEnum.LENT,
      });
    }

    if (!this.showUpgrade) {
      this.$ubtModuleExposeNew('finance_withdrawResult_applyAmount', {
        commodityId: this.commodityId,
        applyStatus: OrderResultEnum.LENT,
      });
    }

    this.$ubtModuleExposeNew('finance_withdrawResultSucceed_withdraw', {
      commodityId: this.commodityId,
      applyStatus: OrderResultEnum.LENT,
    });
  }

  private onChannelClick(channel: PreApplyItem) {
    handleChannelClick(this, channel, 'finance_withdrawResultSucceed_withdraw', OrderResultEnum.LENT);
  }

  // 实际放款金额
  private get amount(): string {
    return String(this.orderDetail ? this.orderDetail.amount : '');
  }

  // 出资方信息
  private get investors(): OrdersV2.InvestorData[] {
    return (this.orderDetail ? this.orderDetail.investors : []) || [];
  }

  // 收款账户信息信息
  private get receiveAccountText(): string {
    const { bankName = '', cardNo = '' } = this.orderDetail
      ? this.orderDetail.loanUserBankInfo
      : {};

    return this.cardBindType === CardBindTypeEnum.ALIPAY ? '支付宝'
      : `${bankName}(${cardNo.slice(-4)})`;
  }

  // 出资方列表
  private get renderInvestors(): JSX.Element {
    return (
      <div class={style.investors}>
        {this.investors.map((investor) => (
          <span key={investor.name} class={style.investorItem}>
            <span class={style.name}>{investor.name}</span>
            {investor.rate && <span class={style.numeric}>{investor.rate * 100}%</span>}
          </span>
        ))}
      </div>
    );
  }

  // 需要展示条目
  private get detailInfoList() {
    const { commodityName = '' } = this.commodityDetail || {};
    return [
      {
        name: '放款机构',
        // 马上渠道、自营渠道场景，只展示出资方，需要隐藏放款机构
        disabled: this.commodityId === MASHANG_COMMODITY
          || this.commodityId === ProductCommodity.AUTARKY_B_COMMODITY,
        value: commodityName,
      },
      {
        name: '出资方',
        disabled: !this.investors.length,
        value: this.renderInvestors,
      },
      {
        name: '收款账户',
        value: this.receiveAccountText,
      },
    ];
  }

  private renderInfoList() {
    return (
      <div>
        {this.detailInfoList.map((item) => (
          !item.disabled && (
            <div class={style.cellItem}>
              <div class={style.label}>{item.name}</div>
              <div class={style.content}>{item.value}</div>
            </div>
          )
        ))
        }
      </div>
    );
  }

  private render() {
    return (
      <tempalte>
        <NewResultPage
          status={ResultPageStatusEnum.SUCCESS}
          statusText={`恭喜您！${this.amount}元提现成功!`}
        />
        <div class={style.infoList}>
          {this.renderInfoList()}
        </div>
        {/* 内嵌协议 slot */}
        {this.$scopedSlots.contract && this.$scopedSlots.contract({})}
        {/* 分期申请状态轮询卡片 slot */}
        {this.$scopedSlots.mall && this.$scopedSlots.mall({})}

        {/* 显示老客升级模块
        */}
        {
          this.showUpgrade && this.showPreApply && (
            <div
            class={style.upgradeBanner}
            onClick={this.goPreApply.bind(this)}
            ></div>
          )
        }
        <ChangeChannelList
          commodityId={this.commodityId}
          isNewChannel={true}
          onReApply={this.onChannelClick.bind(this)}
        />
      {/* 没命中老客升级或者非海消隐藏授信入口时，展示 申请新额度按钮 */}
      {((!this.showUpgrade && this.showPreApply)
        || (!this.haiXiaoQueryData?.hideApplyCreditEntry)) && (
          <div
            class={style.applyNewCreditWrapper}
            onClick={this.goPreApply.bind(this)}
          >
            <span class={style.applyNewCredit}>
              申请新额度
            </span>
          </div>
      )}
      </tempalte>
    );
  }
}
